import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  useAreasActions,
  useInterfaceActions,
  selectUser,
  selectCanReviewStones
} from 'state';
import { ROUTES, SIDEBAR_MODE } from '_constants';
import { areasEvents } from '_events';

import { MenuItem, StyledMenu, MenuLink } from './Menu.styles';

export const Menu = () => {
  const history = useHistory();
  const { setSidebarMode } = useAreasActions();
  const { setOpenContactUs } = useInterfaceActions();
  const user = useSelector(selectUser);
  const canReviewStones = useSelector(selectCanReviewStones);
  // TODO: add with subarea
  // const handleOpenFields = () => {
  //   history.push(ROUTES.ROOT, { isOpenSidebar: true });
  //   areasEvents.toggleSidebar(true);
  //   setSidebarMode(SIDEBAR_MODE.FIELDS);
  // };

  const handleOpenReports = () => {
    history.push(ROUTES.ROOT, { isOpenSidebar: true });
    areasEvents.toggleSidebar(true);
    setSidebarMode(SIDEBAR_MODE.AREAS);
  };

  const handleOpenContactUs = () => setOpenContactUs(true);

  return (
    <StyledMenu>
      {/* <MenuItem onClick={handleOpenFields}>Fields</MenuItem> */}
      <MenuItem>
        <MenuLink to={ROUTES.FIELDS}>Areas</MenuLink>
      </MenuItem>
      <MenuItem onClick={handleOpenReports}>Reports</MenuItem>
      <MenuItem>
        <MenuLink to={ROUTES.MODELS}>Geo models</MenuLink>
      </MenuItem>
      {!user?.isDemo && (
        <MenuItem>
          <MenuLink to={ROUTES.EDGE_UNITS}>Edge units</MenuLink>
        </MenuItem>
      )}
      {!!user?.stone_google_folder && (
        <MenuItem>
          <MenuLink to={ROUTES.UPLOAD_MISSIONS}>Upload data</MenuLink>
        </MenuItem>
      )}
      {canReviewStones && (
        <MenuItem>
          <MenuLink to={ROUTES.STONE_REVIEW}>Review</MenuLink>
        </MenuItem>
      )}
      <MenuItem onClick={handleOpenContactUs}>Contact us</MenuItem>
    </StyledMenu>
  );
};
